module.exports = __webpack_public_path__ + "static/media/stress-management-large.ed42d43b.png";